<script>
  export let area;
  import {
    areaView,
    areaListingStay,
    areaListingActivities,
    areaListingEatDrink,
  } from "/guidebook/shared/urls.js";
</script>

<div class="row align-items-center justify-content-between">
  <div class="col-6 d-flex flex-column flex-md-row">
    <a class="h4 text-gray-800" href={areaView(area.country.code, area.slug)}>
      Explore {area.name}
    </a>
  </div>
</div>
<div class="row">
  <div class="col-12">
    Discover other great business in and around {area.name}
  </div>
  <div class="col-12">
    <ul class="list-inline mb-0 mr-2 mr-md-5">
      <li class="list-inline-item">
        <a
          href={areaListingStay(area.country.code, area.slug)}
          class="text-primary text-hover-primary">
          Places to Stay
        </a>
      </li>
      <i class="bi bi-dot" />
      <li class="list-inline-item">
        <a
          href={areaListingActivities(area.country.code, area.slug)}
          class="text-primary text-hover-primary">
          Things to Do
        </a>
      </li>
      <i class="bi bi-dot" />
      <li class="list-inline-item">
        <a
          href={areaListingEatDrink(area.country.code, area.slug)}
          class="text-primary text-hover-primary">
          Places to Eat & Drink
        </a>
      </li>
    </ul>
  </div>
</div>
